<template>
  <div class="LinesChart">
    <linesChart
      type="line"
      :height="height"
      :width="width"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import linesChart from 'vue-apexcharts';
export default {
  name: 'LinesChart',
  components: {
    linesChart,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    series: {
      type: Array,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
  },
};
</script>
